import React from 'react';
import './theme.css';
import CustomButton from './CustomButton';

export default class GLFraksl extends React.Component {
  /*constructor(props)
  {
    super(props);
  }*/

  render(){
    return (
      <div className="ablak">
        <div className="keret">
          <h1>glFraksl</h1>
          <p>A small program to explore fractals.</p>
          <p>Based on the <a href="https://play.google.com/store/apps/details?id=com.workSPACE.Fraksl" target="_blank" rel="noopener noreferrer"><i>Fraksl android app</i></a>.</p>
        </div>
        <div className="keret">
          <img src="images/glFraksl.png" alt="" style={{width: '40.0vw'}}/>
        </div>
        <div className="keret szovegdoboz">
          <h3>Features: (currently wip)</h3>
          <ul>
            <li>Mouse controlled parameters</li>
            <li>Save image</li>
            <li>Render resolution: HDReady, HD, 4K</li>
          </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Planned:</h3>
            <ul>
              <li>Color palettes, animation export</li>
              <li>Message me for feature requests, ideas - <i><a data-email="bezozo97@gmail.com" href="mailto:bezozo97@gmail.com">Contact me</a></i></li>
            </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Requirements:</h3>
            <ul>
              <li>Windows with .Net framework (already installed on newer versions)</li>
              <li>Videocard supporting openGL 3.0 ( year 2008+ videocards)</li>
          </ul>
        </div>
        <div className="keret">
          <p><b>Download:</b></p>
          <p>.zip file containing the executable and example file</p>
          <CustomButton newTab url="https://app.box.com/s/tt3b6l1645l71gwjccog0rmpgonn1g0n" icon='file_download' tooltip="Download"/>
          <p>last update: 2018.04.10.</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/GLFraksl.js